import { SaleorderTypeResponseModel, AllSaleorderTypeResponseModel } from '@gtpl/shared-models/masters';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post,Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { Any } from 'typeorm';
import { SaleorderTypeDTO } from './dto/sale-order-type.dto';
import { SaleOrderTypeService } from './sale-order-type.service';
@ApiTags('sale-order-type')
@Controller('sale-order-type')
export class SaleOrderTypeController {
    constructor(private saleOrderTypeService: SaleOrderTypeService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) {}
    @Post('/createSaleOrderType')
    async createSaleOrderType(@Body() saleOrderTypeDTO:SaleorderTypeDTO,isUpdate:boolean=false,
    ): Promise<SaleorderTypeResponseModel> {
    try {
        return await this.saleOrderTypeService.createSaleorderType(saleOrderTypeDTO, false);
    } catch (error) {
        // return errorHandler(SaleorderTypeResponseModel,error);
        return this.applicationExceptionHandler.returnException(SaleorderTypeResponseModel, error);
    }
    }
  //   @Post('/updateSaleOrderType')
  // async updateSaleOrderType(@Body() saleOrderTypeDTO: SaleorderTypeDTO): Promise<SaleorderTypeResponseModel> {
  //   try {
  //     console.log('update SaleorderType');
  //     return await this.saleOrderTypeService.createSaleorderType(saleOrderTypeDTO, true);
  //   } catch (error) {
  //     // return errorHandler(SaleorderTypeResponseModel, error);
  //     return this.applicationExceptionHandler.returnException(SaleorderTypeResponseModel, error);
  //   }
  // }

  @Post('/updateSaleOrderType')
  async updateSaleOrderType(@Body() saleOrderTypeDTO: SaleorderTypeDTO,@Req() request:Request): Promise<SaleorderTypeResponseModel> {
    try {
      console.log('update SaleorderType');SaleorderTypeDTO
      console.log(request);
      return await this.saleOrderTypeService.createSaleorderType(saleOrderTypeDTO, true);
      // return await this.countriesService.createCountry(countriesDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleorderTypeResponseModel, error);
    }
  }






  @Post('/getAllSaleOrderType')
  // @UseGuards(AuthGuard('jwt'))
  async getAllSaleorderType(): Promise<AllSaleorderTypeResponseModel> {
    try {
      return await this.saleOrderTypeService.getAllSaleorderType();
    } catch (error) {
      // return errorHandler(AllSaleorderTypeResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllSaleorderTypeResponseModel, error);
    }
  }
  @Post('/getAllActiveSaleOrderType')
  async getAllActiveSaleOrderType(@Req() request: Request): Promise<AllSaleorderTypeResponseModel> {
      try {
          return await this.saleOrderTypeService.getAllActiveSaleorderType();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllSaleorderTypeResponseModel, error)
      }
  }
}
